import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["main", "thumbnail"]

  connect() {
    // Set first thumbnail as active
    if (this.thumbnailTargets.length > 0) {
      this.thumbnailTargets[0].parentElement.classList.add("ring-2", "ring-blue-500")
    }
  }

  select(event) {
    const clickedImg = event.currentTarget
    const newSrc = clickedImg.src

    // Update main image
    this.mainTarget.src = newSrc

    // Update active state on thumbnails
    this.thumbnailTargets.forEach(thumb => {
      thumb.parentElement.classList.remove("ring-2", "ring-blue-500")
    })
    clickedImg.parentElement.classList.add("ring-2", "ring-blue-500")
  }
}
